export default __webpack_public_path__ + "static/media/logo.8dae2f5c.png";